import React from 'react';

const GirdedCross = (props) => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M8 16c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm1.414-8l2.122-2.121c.39-.39.39-1.024 0-1.415-.391-.39-1.024-.39-1.415 0L8 6.586 5.879 4.464c-.39-.39-1.024-.39-1.415 0-.39.391-.39 1.024 0 1.415L6.586 8l-2.122 2.121c-.39.39-.39 1.024 0 1.415.391.39 1.024.39 1.415 0L8 9.414l2.121 2.122c.39.39 1.024.39 1.415 0 .39-.391.39-1.024 0-1.415L9.414 8z" />
  </svg>
);

export default GirdedCross;
